import PropTypes from "prop-types";
import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import UploadModal from "../modals/upload-modal";
import AuthModal from "../modals/auth-modal";
import { withTranslation } from "react-i18next";

class ActionButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      style: null,
      classFixed: false,
      classConfirm: false,
      buttons: props.buttons,
      showUploadModal: false,
    };

    this.elem;
    this.scrollTop = 0;

    this.renderButtons = this.renderButtons.bind(this);
    this.addBtn = this.addBtn.bind(this);
    this.fixed = this.fixed.bind(this);
    this.isButtonActive = this.isButtonActive.bind(this);

    this.componentElementRef = React.createRef();
  }

  componentWillUnmount() {
    const wrapperResult = document.getElementsByClassName("wrapper");
    const wrapperElement = wrapperResult ? wrapperResult[0] : null;

    if (wrapperElement) {
      wrapperElement.removeEventListener("scroll", this.fixed);
    }

    window.removeEventListener("scroll", this.fixed);
  }

  fixed() {
    let newStyle;
    let isFixed;
    const { style, classFixed } = this.state;
    const wrapperResult = document.getElementsByClassName("wrapper");
    const wrapperElement = wrapperResult ? wrapperResult[0] : null;

    if (wrapperElement && wrapperElement.scrollTop > 0) {
      this.scrollTop = wrapperElement.scrollTop + 73;
    } else if (window.outerWidth < 769 && window.scrollY > 0) {
      this.scrollTop = window.scrollY + 73;
    } else {
      this.scrollTop = 0;
    }

    if (Math.abs(this.elem.y) < this.scrollTop) {
      newStyle = {
        top: "99px",
        width: `${
          document.querySelector(".react-bootstrap-table") &&
          document.querySelector(".react-bootstrap-table").clientWidth + 2
        }px`,
      };
      isFixed = true;
    } else {
      newStyle = null;
      isFixed = false;
    }

    if (
      classFixed !== isFixed ||
      (style && style.width) !== (newStyle && newStyle.width)
    ) {
      this.setState({
        style: newStyle,
        classFixed: isFixed,
      });
    }
  }

  addBtn(props) {
    const { buttonObj, selectedRows, keyField, t } = props;

    if ((selectedRows && selectedRows.length > 0) || buttonObj.unSelected) {
      const row = selectedRows[0];

      /** Retrun Type Template **/
      switch (buttonObj.type) {
        case "a":
          return (
            <Button
              id={row ? "row" + row[keyField] : buttonObj.name}
              title={t(buttonObj.title)}
              className={"mr-2 btn-xs " + buttonObj.className}
              variant="outline-warning"
              onClick={buttonObj.onClick}
            >
              <span>{t(buttonObj.title)}</span>
            </Button>
          );
        case "b":
          return (
            <a
              id={"button_" + buttonObj.title}
              title={t(buttonObj.title)}
              className={"btn btn-icon btn-action " + buttonObj.className}
              onClick={buttonObj.onClick}
            >
              <span>{t(buttonObj.title)}</span>
            </a>
          );
        case "upload":
          return (
            <UploadModal
              onConfirm={(id) => {
                buttonObj.onConfirm({ id });
              }}
              selectedRow={row}
              requestTo={buttonObj.requestTo}
            >
              <Button
                id={"row" + row[keyField]}
                title={t(buttonObj.title)}
                className={"mr-2 btn-xs" + buttonObj.className}
                variant="outline-warning"
                onClick={buttonObj.onClick}
              >
                <span>{t(buttonObj.title)}</span>
              </Button>
            </UploadModal>
          );
        case "auth":
          return (
            <AuthModal
              onConfirm={(id) => {
                buttonObj.onConfirm({ id });
              }}
              selectedRow={row}
              requestTo={buttonObj.requestTo}
            >
              <Button
                id={"row" + row[keyField]}
                title={t(buttonObj.title)}
                className={"mr-2 btn-xs" + buttonObj.className}
                variant="outline-warning"
                onClick={buttonObj.onClick}
              >
                <span>{t(buttonObj.title)}</span>
              </Button>
            </AuthModal>
          );
        default:
          console.warn("No Type");
          break;
      }
    }

    return null;
  }

  isButtonActive(button, selectedRows) {
    if (typeof button.isActive === "function") {
      return selectedRows.every((r) => button.isActive(r));
    }

    return button.isActive;
  }

  renderButtons() {
    const { selectedRows, keyField, buttons, t } = this.props;
    let result = [];

    for (const key in buttons) {
      if (buttons.hasOwnProperty(key)) {
        const button = buttons[key];

        if (
          selectedRows.length > 0 &&
          (selectedRows.length === 1 || button.multi) &&
          this.isButtonActive(button, selectedRows)
        ) {
          result.push(
            <this.addBtn
              key={key}
              buttonObj={button}
              selectedRows={selectedRows}
              keyField={keyField}
              t={t}
            />
          );
        } else if (button.unSelected) {
          result.push(
            <this.addBtn
              key={key}
              buttonObj={button}
              selectedRows={selectedRows}
              keyField={keyField}
              t={t}
            />
          );
        }
      }
    }

    return result;
  }

  render() {
    const { t } = this.props; /* added line */
    const { selectedRows } = this.props;
    const { style } = this.state;

    return (
      <div
        style={{
          padding: "10px",
        }}
      >
        <div className="row">
          <div className="col-md-12">
            {/* {
              // Selected Size
              selectedRows.length > 0 && (
                <p className="selected-label text-primary">
                  {selectedRows.length} {t("actionButtonGenerator.ogeSecildi")}
                  <i className="icon-check-mark-2" />
                </p>
              )
            } */}
            {/* <span className="text-primary">{t("actionButtons.islemler")} </span> */}

            <this.renderButtons t={t} />
          </div>
        </div>
      </div>
    );
  }
}

ActionButtons.propTypes = {
  enterAction: PropTypes.string,
  buttons: PropTypes.objectOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      title: PropTypes.string,
      multi: PropTypes.bool,
      className: PropTypes.string,
      icon: PropTypes.string,
    })
  ),
};

export default withTranslation()(ActionButtons);
